import { AxiosResponse } from 'axios';
import Request from '@/api/Request';
import { Response } from '@/model';
import {
  CreditCostSummary,
  CreditExtraPurchaseResult,
  CreditPricing,
  CreditStatus,
  PaymentCardInfo,
  PaymentInfo,
  RecentInvoiceItem
} from '@/model/BillingPlan';

export default class BillingApi {
  static getInvoiceList(page: number): Promise<AxiosResponse<Response<RecentInvoiceItem[]>>> {
    return Request.get('/v2/payment/invoices', { params: { page } });
  }

  static getBindCardInfo(): Promise<AxiosResponse<Response<PaymentCardInfo>>> {
    return Request.get('/v2/payment/card');
  }

  static updateCard({
    token
  }: {
    token: string
  }): Promise<AxiosResponse<Response<any>>> {
    return Request.post('/v2/payment/card/update', { token });
  }

  static getPaymentInfo(): Promise<AxiosResponse<Response<PaymentInfo>>> {
    return Request.get('/v2/payment/info');
  }

  static getCreditStatus(): Promise<AxiosResponse<Response<CreditStatus>>> {
    return Request.get('/v2/payment/credit');
  }

  static getCreditCost(): Promise<AxiosResponse<Response<CreditCostSummary>>> {
    return Request.get('/v2/payment/credit/cost');
  }

  static getCreditPricing(): Promise<AxiosResponse<Response<CreditPricing>>> {
    return Request.get('/v2/payment/credit/pricing');
  }

  static buyExtraCredits({
    amountUsd
  }: {
    amountUsd: number
  }): Promise<AxiosResponse<Response<CreditExtraPurchaseResult>>> {
    return Request.post('/v2/payment/credit/extra', {
      amount_usd: amountUsd
    });
  }

  static toggleExtraCredits({
    enable
  }: {
    enable: boolean
  }): Promise<AxiosResponse<Response<null>>> {
    return Request.post('/v2/payment/credit/extra/toggle', {
      enable
    });
  }

  /**
   * 订阅套餐
   * @param subscriptionPlan 要订阅定套餐
   */
  static subscribePlan({
    subscriptionPlan
  }: {
    subscriptionPlan: number
  }): Promise<AxiosResponse<Response<any>>> {
    return Request.post('/v2/payment/subscription/update', {
      subscription_plan: subscriptionPlan
    });
  }
}
